<template>
  <div :class="[$style['adl-mds-datatable-list'], $style['datatable-group']]">
    <div :class="$style['mds-card__title']">
      {{ datatablelistconfig.listTitle }}
    </div>
    <div :class="$style['cf-supportingText']">
      {{ datatablelistconfig.listDescription }}
    </div>
    <div :class="$style['table-wrapper']">
      <adl-editable-data-table
        v-for="data in datatablelistconfig.editableDataTableData"
        :headers="datatablelistconfig.headers"
        :rows="data.rows"
        :blankrow="data.blankrow"
        :groupType="data.groupType"
        :emptyStateTitle="data.emptyStateTitle"
        :emptyStateMessage="data.emptyStateMessage"
        :tableHeadingName="data.tableHeadingName"
        :parentGroupId="datatablelistconfig.parentGroupId"
        @addNewRow="addNewRow"
        @eventActionHandler="eventActionHandler"
      ></adl-editable-data-table>
    </div>
  </div>
</template>
<script>
import AdlEditableDataTable from "../editable-data-table/EditableDataTable.vue";

export default {
  inheritAttrs: false,

  props: {
    datatablelistconfig: {
      type: Object,
      required: true,
    },
    rows: {
      type: Array,
    },
    blankrow: {
      type: Object,
    },
  },
  components: {
    AdlEditableDataTable,
  },
  computed: {},
  methods: {
    eventActionHandler(methodName, data, currencyFormat) {
      this.$emit("eventActionHandler", methodName, data, currencyFormat);
    },
    addNewRow(data) {
      this.$emit("addNewRow", data);
    },
    deleteRow(row) {
      this.$emit("deleteRow", row);
    },
  },
};
</script>

<style lang="scss" module>
@import "@mds/constants";
@import "@mds/typography";
.datatable-group {
  border: $mds-border-separator-on-light;
  padding: $mds-space-3-x $mds-space-4-x;
  border-radius: $mds-space-1-x;
  background-color: $mds-background-color-white !important;
  margin-top: $mds-space-1-x;
}
.adl-mds-datatable-list {
  .table-wrapper {
    margin-top: $mds-space-4-x;
  }
  .cf-supportingText {
    padding-bottom: $mds-space-1-x;
    color: $mds-text-color-secondary;
    font-size: 14px;
  }
  .mds-card__title {
    @include mds-text-crop();
    @include mds-level-5-heading($bold: true);

    border-top: solid 2px transparent; // required for text-crop() reasons
    color: $mds-text-color-primary;
    display: block;
    margin-bottom: $mds-space-1-and-a-half-x;
    margin-top: -2px; // required for text-crop() reasons

    &:last-child {
      margin-bottom: 20px;
    }
  }
}
</style>
